@if (SimConfigurationService.settings.environmentEnabled) {
	<sim-environment-overlay [info]="systemInfo" />
}
